export default "/images/pageview.png?63e6a9dba5b1c81c240bd7fc91d38dd1";